module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Light.woff?ed7b6ef663be5791996d1109ce18f242";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Light.woff
// module id = 1392
// module chunks = 0